export default {
  'account-settings.menuMap.basic': '基本設置',
  'account-settings.menuMap.security': '安全設置',
  'account-settings.menuMap.binding': '賬號綁定',
  'account-settings.menuMap.notification': '新消息通知',
  'account-settings.basic.avatar': '頭像',
  'account-settings.basic.change-avatar': '更換頭像',
  'account-settings.basic.email': '郵箱',
  'account-settings.basic.email-message': '請輸入您的郵箱!',
  'account-settings.basic.nickname': '昵稱',
  'account-settings.basic.nickname-message': '請輸入您的昵稱!',
  'account-settings.basic.profile': '個人簡介',
  'account-settings.basic.profile-message': '請輸入個人簡介!',
  'account-settings.basic.profile-placeholder': '個人簡介',
  'account-settings.basic.country': '國家/地區',
  'account-settings.basic.country-message': '請輸入您的國家或地區!',
  'account-settings.basic.geographic': '所在省市',
  'account-settings.basic.geographic-message': '請輸入您的所在省市!',
  'account-settings.basic.address': '街道地址',
  'account-settings.basic.address-message': '請輸入您的街道地址!',
  'account-settings.basic.phone': '聯系電話',
  'account-settings.basic.phone-message': '請輸入您的聯系電話!',
  'account-settings.basic.update': '更新基本信息',
  'account-settings.basic.update.success': '更新基本信息成功',
  'account-settings.security.strong': '強',
  'account-settings.security.medium': '中',
  'account-settings.security.weak': '弱',
  'account-settings.security.password': '賬戶密碼',
  'account-settings.security.password-description': '當前密碼強度：',
  'account-settings.security.phone': '密保手機',
  'account-settings.security.phone-description': '已綁定手機：',
  'account-settings.security.question': '密保問題',
  'account-settings.security.question-description': '未設置密保問題，密保問題可有效保護賬戶安全',
  'account-settings.security.email': '備用郵箱',
  'account-settings.security.email-description': '已綁定郵箱：',
  'account-settings.security.mfa': 'MFA 設備',
  'account-settings.security.mfa-description': '未綁定 MFA 設備，綁定後，可以進行二次確認',
  'account-settings.security.modify': '修改',
  'account-settings.security.set': '設置',
  'account-settings.security.bind': '綁定',
  'account-settings.binding.taobao': '綁定淘寶',
  'account-settings.binding.taobao-description': '當前未綁定淘寶賬號',
  'account-settings.binding.alipay': '綁定支付寶',
  'account-settings.binding.alipay-description': '當前未綁定支付寶賬號',
  'account-settings.binding.dingding': '綁定釘釘',
  'account-settings.binding.dingding-description': '當前未綁定釘釘賬號',
  'account-settings.binding.bind': '綁定',
  'account-settings.notification.password': '賬戶密碼',
  'account-settings.notification.password-description': '其他用戶的消息將以站內信的形式通知',
  'account-settings.notification.messages': '系統消息',
  'account-settings.notification.messages-description': '系統消息將以站內信的形式通知',
  'account-settings.notification.todo': '待辦任務',
  'account-settings.notification.todo-description': '待辦任務將以站內信的形式通知',
  'account-settings.settings.open': '開',
  'account-settings.settings.close': '關',
};
